import { useContext, useMemo } from "react";
import { DigitalSignageDataContext } from "contexts/DigitalSignageDataContext";
import { appSettings } from "helpers";
import linq from "linq";
import { useCallback } from "react";

export interface IData {
  deviceConfiguration: IDeviceConfiguration;
  playlistItem: IPlaylistItem;
}

export interface IDeviceConfiguration {
  deviceName: string;
  viewportWidth: number;
  viewportHeight: number;
  viewportLeftOffset: number;
  viewportTopOffset: number;
  viewportRotation: number;
  viewportScale: number;
  playlists: any[];
  mediaGrids: any;
  medias: { key: string; value: IMedia };
  defaultContent: any;
  group: any;
  tags: any[];
  properties: any;
  deviceNotBoundToGroup: boolean;
  deviceNotAllowedSynchronizationTimeRange: boolean;
}

export interface IPlaylistItem {
  id: string;
  type: string;
  readingMode: "sequential" | "frequential" | "punctual" | "eventBased";
  order: number;
  playlistId: string;
  mediaId: string;
  mediaGridId: string;
  configuration: any;
}

export interface IMedia {
  id: string;
  name: string;
  type: string;
  path: string;
  thumbnailPath: string;
  configuration: any;
  tags: any[];
  offlineStorageSource: boolean;
}

export default function useImko() {
  const { data }: { data: IData } = useContext(DigitalSignageDataContext);

  const getCurrentPlaylistItemMediaConfiguration = useCallback(
    (label: string) => {
      const mediaId = data?.playlistItem?.mediaId;
      if (
        mediaId !== null &&
        mediaId !== "" &&
        data.deviceConfiguration?.medias
      ) {
        const media = linq
          .from(data.deviceConfiguration.medias)
          .where((o) => o.key === mediaId)
          .firstOrDefault()?.value as IMedia;
        return media?.configuration?.[label];
      } else {
        return null;
      }
    },
    [data]
  );

  const offerCount = useMemo(() => {
    let result = 1;
    try {
      const offerCount = parseInt(
        getCurrentPlaylistItemMediaConfiguration("offerCount")
      );
      result = offerCount > 0 ? offerCount : result;
    } catch (error) {
      result = 1;
    }
    return result;
  }, [getCurrentPlaylistItemMediaConfiguration]);

  const showNextOffersPopup = useMemo(() => {
    let result = true;
    try {
      const value = getCurrentPlaylistItemMediaConfiguration(
        "showNextOffersPopup"
      );
      if (value === true || value === "true" || value === 1 || value === "1") {
        result = true;
      } else {
        result = false;
      }
    } catch (error) {
      result = true;
    }
    return result;
  }, [getCurrentPlaylistItemMediaConfiguration]);

  const deviceName = useMemo(
    () =>
      appSettings["deviceName"] ??
      data?.deviceConfiguration?.deviceName ??
      (window as any)?.config?.deviceName ??
      null,
    [data?.deviceConfiguration?.deviceName]
  );

  const playlistItem = useMemo(() => data?.playlistItem, [data?.playlistItem]);

  const playlistItems = useMemo(
    () => data?.deviceConfiguration?.playlists?.[0]?.playlistItems,
    [data?.deviceConfiguration?.playlists]
  );

  return {
    data,
    deviceName,
    offerCount,
    showNextOffersPopup,
    playlistItem,
    playlistItems,
  };
}
